import { combineReducers } from 'redux';

const step = (state = 1, { initialStep = 1, type }: any) => {
  switch (type) {
    case 'NEXT_STEP_WIZARD_NP':
      return state + 1;
    case 'PREVIOUS_STEP_WIZARD_NP':
      return state - 1;
    case 'RESET_WIZARD_NP':
      return initialStep;
    default:
      return state;
  }
};

const selected = (state = 0, { type, value, initialSelected = 1 }: any) => {
  switch (type) {
    case 'SET_VALUE_WIZARD_NP':
      return value;
    case 'RESET_VALUE_WIZARD_NP':
      return initialSelected;
    default:
      return state;
  }
};

const loading = (state = { active: false, percent: 0 }, action: any) => {
  switch (action.type) {
    case 'UPDATE_LOAD_WIZARD_NP':
      return { active: true, percent: action.percent };
    case 'RESET_LOAD_WIZARD_NP':
      return { active: false, percent: 0 };
    default:
      return state;
  }
};

const product = (state = {}, action: any) => {
  switch (action.type) {
    case 'INSERT_PRODUCT_WIZARD_NP':
      return action.product;
    case 'RESET_PRODUCT_WIZARD_NP':
      return {};
    default:
      return state;
  }
};

export const reducer = combineReducers({
  step,
  selected,
  loading,
  product,
});
